//两个时间相差天数 sDate1和sDate2是yyyy-MM-dd格式
export function dateDiff(sDate1, sDate2) {
  var aDate, oDate1, oDate2, iDays
  aDate = sDate1.split("-")
  oDate1 = new Date(aDate[1] + '-' + aDate[2] + '-' + aDate[0])    //转换为02-05-2018格式
  aDate = sDate2.split("-")
  oDate2 = new Date(aDate[1] + '-' + aDate[2] + '-' + aDate[0])
  iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24)    //把相差的毫秒数转换为天数
  return iDays
}

// 获取当前时间
export  function getFormatDate(date) {
  var month = date.getMonth() + 1
  var strDate = date.getDate()
  if (month >= 1 && month <= 9) {
    month = '0' + month
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = '0' + strDate
  }
  var currentDate = date.getFullYear() + '-' + month + '-' + strDate + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds()
  return currentDate
}

//最近一天
export function getLatestDay() {
  const end = getFormatDate(new Date());
  const start = getFormatDate(new Date(new Date() - 3600 * 1000 * 24));
  return [start, end];
}

//最近一个月
export function getLatestMonth() {
  const end = getFormatDate(new Date()).substr(0, 10);
  const start = getFormatDate(new Date(new Date() - 3600 * 1000 * 24 * 30)).substr(0, 10);
  return [start, end];
}

//最近一年
export function getLatestYear() {
  const end = getFormatDate(new Date()).substr(0, 10);
  const start = getFormatDate(new Date(new Date() - 3600 * 1000 * 24 * 365)).substr(0, 10);
  return [start, end];
}
